// extracted by mini-css-extract-plugin
export default {"fillet":"IOListsInput_fillet__F3ELV","iconDelete":"IOListsInput_iconDelete__6vgix","innerContainer":"IOListsInput_innerContainer__OHMGl"};